/* GRWM liquid page transitions.
   Native: cross-document View Transitions (Chrome/Edge/Android, Safari 18.2+) - zero delay, GPU composited.
   Fallback: 200ms liquid veil from the tap point, then the next page reveals from the same point. */
(function(){
  var d=document,h=d.documentElement;
  if(h.classList.contains('shopify-design-mode'))return;
  if(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  var native='CSSViewTransitionRule' in window;
  var SKIP=['/checkout','/cart/add','/cart/change','/cart/update','/cart/clear','/account/logout','/apps/'];
  function skip(p){for(var i=0;i<SKIP.length;i++){if(p.indexOf(SKIP[i])===0)return true;}return false;}
  function target(a,e){
    if(!a||e.defaultPrevented||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return null;
    if(a.target&&a.target!=='_self')return null;
    if(a.hasAttribute('download')||a.hasAttribute('data-no-transition'))return null;
    var raw=a.getAttribute('href');if(!raw||raw.charAt(0)==='#'||/^(mailto|tel|sms|javascript):/i.test(raw))return null;
    var u;try{u=new URL(a.href,location.href);}catch(_){return null;}
    if(u.origin!==location.origin||skip(u.pathname))return null;
    if(u.pathname===location.pathname&&u.search===location.search)return null;
    return u;
  }
  function veil(x,y){
    var o=d.createElement('div');o.className='gvt-veil';o.setAttribute('aria-hidden','true');
    o.style.setProperty('--gvt-x',x);o.style.setProperty('--gvt-y',y);d.body.appendChild(o);
    o.getBoundingClientRect();o.classList.add('on');return o;
  }
  d.addEventListener('click',function(e){
    var a=e.target&&e.target.closest?e.target.closest('a[href]'):null;var u=target(a,e);if(!u)return;
    var x='50%',y='50%';
    if(e.clientX||e.clientY){x=(e.clientX/innerWidth*100).toFixed(1)+'%';y=(e.clientY/innerHeight*100).toFixed(1)+'%';}
    try{sessionStorage.setItem('gvt',x+' '+y);}catch(_){}
    if(native)return; /* browser runs the view transition itself */
    e.preventDefault();veil(x,y);
    setTimeout(function(){location.href=u.href;},190);
  });
  /* back/forward cache: never leave a veil on screen */
  addEventListener('pageshow',function(){var v=d.querySelectorAll('.gvt-veil');for(var i=0;i<v.length;i++)v[i].remove();});
})();